module.exports = __webpack_public_path__ + "static/media/arrow_right.498db702.svg";